import React from 'react';
import { Outlet } from 'react-router-dom'; // Make sure to import Outlet
import Sidebar from './Sidebar';
import Header from './Header';

const AdminLayout = () => {
  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-6">
          <Outlet /> {/* This is where the child routes will be rendered */}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;